import { MenuItem } from "../../core/models/MenuItem";
import * as menu from "../actions/menu"

export function reducer(state: MenuItem[] = null, action: menu.MenuAction) {
    if (action.type == menu.UPDATEMENU) {
        return [...action.getMenu()];
    } else
        return state;
}